/**
 * F-021 — Pause badge UI.
 *
 * Subscribes to the pause controller and reveals a centered "Paused"
 * label when active. Pure DOM, pointer-events none so it doesn't
 * intercept clicks.
 */

import type { PauseController } from "../game/pause-controller.ts";
import { t } from "../i18n/index.ts";

export interface PauseBadge {
  element: HTMLDivElement;
  detach(): void;
}

export function attachPauseBadge(
  controller: PauseController,
  host: HTMLElement,
): PauseBadge {
  const element = document.createElement("div");
  element.dataset["testid"] = "pause-badge";
  element.className =
    "pointer-events-none absolute inset-0 flex items-center justify-center text-3xl font-display text-cosmic-star opacity-0 transition-opacity duration-200";
  element.textContent = t("pause.label");
  host.appendChild(element);

  const apply = (paused: boolean): void => {
    element.style.opacity = paused ? "1" : "0";
  };

  apply(controller.isPaused());
  const off = controller.onChange(apply);

  const detach = (): void => {
    off();
    element.remove();
  };

  return { element, detach };
}
